// extracted by mini-css-extract-plugin
module.exports = {"BossTrailer":"BossTrailer_BossTrailer__v-ni9","Title":"BossTrailer_Title__3rs_i","Img":"BossTrailer_Img__pt1hZ","Btn":"BossTrailer_Btn__5t1Z6"};